import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import Select from 'components/ui/Select';
import TextInput from 'components/ui/TextInput';
import { Row, Column } from 'components/shared/Layout';
import { StyledLabel, StyledUserSearchForm, StyledButton } from './UserSearchForm.styles';

const UserSearchForm = ({ offices, username, officeCode, setUserDetails }) => {
  const { handleSubmit, register } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      officeCode,
      username
    }
  });

  const onSubmit = (formData) => {
    setUserDetails({
      username: formData.username,
      officeCode: formData.officeCode
    });
  };

  return (
    <StyledUserSearchForm onSubmit={handleSubmit(onSubmit)}>
      <Row columns={12} gutter="32px" marginBottom="0">
        <Row span={5} noGutter>
          <StyledLabel htmlFor="username">
            <FormattedMessage id="shifts.username" />:
          </StyledLabel>
          <TextInput data-cy="username" type="text" id="username" placeholder="Username" {...register('username', { required: true })} />
        </Row>

        <Row span={5} noGutter>
          <StyledLabel htmlFor="officeCode">
            <FormattedMessage id="shifts.location" />:
          </StyledLabel>
          <Select id="officeCode" {...register('officeCode', { required: true })}>
            {offices.map((office) => (
              <option key={office.name} value={office.name}>
                {office.description}
              </option>
            ))}
          </Select>
        </Row>

        <Column span={2} alignItems="flex-end" justifyContent="center">
          <StyledButton data-cy="user-search" type="submit">
            <FormattedMessage id="shifts.search" />
          </StyledButton>
        </Column>
      </Row>
    </StyledUserSearchForm>
  );
};

UserSearchForm.propTypes = {
  offices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string
    })
  ),
  username: PropTypes.string,
  officeCode: PropTypes.string,
  setUserDetails: PropTypes.func
};

UserSearchForm.defaultProps = {
  offices: [],
  username: '',
  officeCode: ''
};

export default UserSearchForm;
